enum WorkOrderFromToType {
  None = "None",
  Account = "Account",
  ServiceProvider = "ServiceProvider",
}

export default WorkOrderFromToType;
